export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9043.00272a02.jpg";